'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _networkErrors = require('MeetingsLib/redux/reducers/networkErrors');

var _networkErrors2 = _interopRequireDefault(_networkErrors);

var _branding = require('MeetingsLib/redux/reducers/branding');

var _branding2 = _interopRequireDefault(_branding);

var _bookingLifecycle = require('MeetingsLib/redux/reducers/bookingLifecycle');

var _bookingLifecycle2 = _interopRequireDefault(_bookingLifecycle);

var _portalId = require('MeetingsLib/redux/reducers/portalId');

var _portalId2 = _interopRequireDefault(_portalId);

var _stagedFormState = require('MeetingsLib/redux/reducers/stagedFormState');

var _stagedFormState2 = _interopRequireDefault(_stagedFormState);

var _formState = require('MeetingsLib/redux/reducers/formState');

var _formState2 = _interopRequireDefault(_formState);

var _bookInfo = require('MeetingsLib/redux/reducers/bookInfo');

var _bookInfo2 = _interopRequireDefault(_bookInfo);

var _isSalesStarter = require('MeetingsLib/redux/reducers/isSalesStarter');

var _isSalesStarter2 = _interopRequireDefault(_isSalesStarter);

var _profile = require('MeetingsLib/redux/reducers/profile');

var _profile2 = _interopRequireDefault(_profile);

var _userMessage = require('MeetingsLib/redux/reducers/userMessage');

var _userMessage2 = _interopRequireDefault(_userMessage);

var _userTimezone = require('MeetingsLib/redux/reducers/userTimezone');

var _userTimezone2 = _interopRequireDefault(_userTimezone);

var _requestStatus = require('MeetingsLib/redux/reducers/requestStatus');

var _requestStatus2 = _interopRequireDefault(_requestStatus);

var _activeLocale = require('MeetingsLib/redux/reducers/activeLocale');

var _activeLocale2 = _interopRequireDefault(_activeLocale);

var _companyName = require('MeetingsLib/redux/reducers/companyName');

var _companyName2 = _interopRequireDefault(_companyName);

var _stagedLegalConsentResponses = require('MeetingsLib/redux/reducers/stagedLegalConsentResponses');

var _stagedLegalConsentResponses2 = _interopRequireDefault(_stagedLegalConsentResponses);

var _legalConsentResponses = require('MeetingsLib/redux/reducers/legalConsentResponses');

var _legalConsentResponses2 = _interopRequireDefault(_legalConsentResponses);

var _troubleshooting = require('MeetingsLib/redux/reducers/troubleshooting');

var _troubleshooting2 = _interopRequireDefault(_troubleshooting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  requestStatus: _requestStatus2.default,
  bookingLifecycle: _bookingLifecycle2.default,
  networkErrors: _networkErrors2.default,
  branding: _branding2.default,
  portalId: _portalId2.default,
  stagedFormState: _stagedFormState2.default,
  formState: _formState2.default,
  bookInfo: _bookInfo2.default,
  isSalesStarter: _isSalesStarter2.default,
  profile: _profile2.default,
  userMessage: _userMessage2.default,
  userTimezone: _userTimezone2.default,
  activeLocale: _activeLocale2.default,
  companyName: _companyName2.default,
  stagedLegalConsentResponses: _stagedLegalConsentResponses2.default,
  legalConsentResponses: _legalConsentResponses2.default,
  troubleshooting: _troubleshooting2.default,
  trackingParams: function trackingParams() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  prefilledCustomFormFields: function prefilledCustomFormFields() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  localeFromProps: function localeFromProps() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  userSlug: function userSlug() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  embedded: function embedded() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return state;
  },
  forceOffline: function forceOffline() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return state;
  },
  queryParams: function queryParams() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return state;
  },
  currentTime: function currentTime() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  initTrackingForMeetings: function initTrackingForMeetings() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  onSuccess: function onSuccess() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  forceMobile: function forceMobile() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  parentPageHSAnalyticsInfo: function parentPageHSAnalyticsInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/reducers/root.js
// module id = 518
// module chunks = 0